module.exports = __webpack_public_path__ + "e07a8bd5fd0079b2c6c8d3c99c92a32b.fbx";